import placeholderImage from 'assets/img/covers/placeholder.jpg';
import { Form } from 'components';
import SelectedItems from 'pages/ModulePage/components/SelectedItems/SelectedItems';
import SelectItemsModal from 'pages/ModulePage/components/SelectItemsModal/SelectItemsModal';
import { useFormikContext } from 'formik';
import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

const getLocationKey = (location) => location.uid;

const filterLocationBySearch = (location, query) => {
  const normalizedQuery = query.toLowerCase();
  return (
    (location.name || '').toLowerCase().includes(normalizedQuery) ||
    (location.address?.city || '').toLowerCase().includes(normalizedQuery)
  );
};

const getLocationItemCardProps = (location, { t }) => ({
  imageSrc: location.cover_image || location.logo || placeholderImage,
  imageAlt: location.name || 'Location',
  title: location.name || null,
  meta: location.address?.city ? [{ label: t('city'), value: location.address.city }] : [],
});

export const createLocationsConfig = (useAvailableItems) => {
  const LocationsConfig = () => {
    const { t } = useTranslation('ownerPortal', { keyPrefix: 'pageModules' });
    const { values, setFieldValue } = useFormikContext();
    const { items, isLoading } = useAvailableItems();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [search, setSearch] = useState('');

    const selectedItems = useMemo(() => values.selectedItems || [], [values.selectedItems]);

    const filteredItems = useMemo(() => {
      if (!search.trim()) return items;
      return items.filter((item) => filterLocationBySearch(item, search.trim()));
    }, [items, search]);

    return (
      <>
        <Form.GroupHorizontal label={t('selectedItems')}>
          <SelectedItems
            isLoading={isLoading}
            items={selectedItems}
            setItems={(next) => setFieldValue('selectedItems', next)}
            getItemKey={getLocationKey}
            getItemCardProps={getLocationItemCardProps}
            onOpenModal={() => setIsModalOpen(true)}
          />
        </Form.GroupHorizontal>
        <SelectItemsModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          onSelect={(next) => setFieldValue('selectedItems', next)}
          initialSelected={selectedItems}
          items={filteredItems}
          isLoading={isLoading}
          getItemKey={getLocationKey}
          getItemCardProps={getLocationItemCardProps}
          onSearch={setSearch}
        />
      </>
    );
  };

  return LocationsConfig;
};
